import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { GuardarOtComponent } from "./guardar-ot/guardar-ot.component";
import { OtComponent } from "./ot.component";
import { MaterialModule } from "../../components/material/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { OtService } from "../../providers/ot.service";
import { PipesModule } from "../../pipes/pipes.module";
import { ArchivoModule } from "../../components/archivo/archivo.module";
import { TablaOtComponent } from './tabla-ot/tabla-ot.component';
import { DetalleModule } from "../../components/detalle/detalle.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { AccesorioService } from "../../providers/accesorio.service";
import { ComunicacionService } from "../../providers/comunicacion.service";
import { ProductoService } from "../../providers/producto.service";
import { CaracteristicasModule } from "../../components/productos/caracteristicas/caracteristicas.module";
import { BotonActionModule } from "../../components/boton-action/boton-action.module";
import { ProductoOtModule } from "./producto-ot/producto-ot.module";
import { CotizacionService } from "../../providers/cotizacion.service";
import { MostrarItemModule } from "../cotizaciones/items/mostrar-item/mostrar-item.module";
import { ImprimirComponent } from './imprimir/imprimir.component';
import { CaracteristicaService } from "../../providers/caracteristica.service";
import { CaracteristicaInputModule } from "../../components/caracteristica-input/caracteristica-input.module";
import { ConfirmModule } from "../../components/confirm/confirm.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        ArchivoModule,
        DetalleModule,
        NgSelectModule,
        PipesModule,
        CaracteristicasModule,
        BotonActionModule,
        ProductoOtModule,
        MostrarItemModule,
        CaracteristicaInputModule,
        ConfirmModule,
    ],
    declarations: [
        GuardarOtComponent,
        OtComponent,
        TablaOtComponent,
        ImprimirComponent,
    ],
    providers: [
        OtService,
        ProductoService,
        ComunicacionService,
        AccesorioService,
        CotizacionService,
        CaracteristicaService,
    ],
    entryComponents: [
        OtComponent,
        ImprimirComponent,
    ],
    exports: [
        GuardarOtComponent,
        TablaOtComponent,
    ]
})
export class OtModule { }